import * as React from 'react';
import Grid from '@material-ui/core/Grid';

const CustomGrid = (props) => {
    return <Grid {...props} />;
};

export { CustomGrid as Grid };
